export async function readApiError(res) {
  try {
    const data = await res.json();
    return data.detail || data.error || `Request failed (${res.status})`;
  } catch {
    return `Request failed (${res.status})`;
  }
}

export async function apiFetch(url, options = {}) {
  const isFormData = typeof FormData !== 'undefined' && options.body instanceof FormData;
  const shouldSetJsonType = options.body && !isFormData;
  const headers = {
    ...(shouldSetJsonType ? { 'Content-Type': 'application/json' } : {}),
    ...(options.headers || {}),
  };
  return fetch(url, {
    credentials: 'same-origin',
    ...options,
    headers,
  });
}

export async function apiJson(url, options = {}) {
  const res = await apiFetch(url, options);
  if (!res.ok) throw new Error(await readApiError(res));
  return res.json();
}

export async function fetchCareProfile(plantId) {
  const res = await apiFetch(`/plants/${plantId}/care-profile`);
  if (res.status === 404) return null;
  if (!res.ok) throw new Error(await readApiError(res));
  return res.json();
}

export async function requestCareProfile(plantId) {
  const res = await apiFetch(`/plants/${plantId}/care-profile/request`, { method: 'POST' });
  if (!res.ok) throw new Error(await readApiError(res));
  return res.json();
}

export async function fetchExplore(q, limit = 40, offset = 0) {
  const params = new URLSearchParams({ limit, offset });
  if (q) params.set('q', q);
  const res = await apiFetch(`/explore?${params}`);
  if (!res.ok) throw new Error(await readApiError(res));
  return res.json();
}

export async function fetchExploreDetail(genus, species) {
  const res = await apiFetch(`/explore/${encodeURIComponent(genus)}/${encodeURIComponent(species)}`);
  if (res.status === 404) return null;
  if (!res.ok) throw new Error(await readApiError(res));
  return res.json();
}
